import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Trade } from '../../types/entities';

import { initialState, RecentTradeState } from './state';

const recentTradeSlice = createSlice({
  name: 'recent-trades',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: RecentTradeState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
      state.pending = false;
    },
    pending: (state: RecentTradeState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.pending = action.payload;
    },
    success: (state: RecentTradeState, action: PayloadAction<Trade[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.trades = action.payload;
    },
    fail: (state: RecentTradeState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.trades = [];
    },
    add: (state: RecentTradeState, action: PayloadAction<Trade>) => {
      state.trades.push(action.payload);
      state.loading = false;
      state.loaded = true;
    },
    update: (state: RecentTradeState, action: PayloadAction<Trade>) => {
      const dbEntry = state.trades.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.trades.indexOf(dbEntry);
        state.trades[index] = action.payload;
      }
      state.pending = false;
    },
    remove: (state: RecentTradeState, action: PayloadAction<Trade>) => {
      const entry = state.trades.find((x) => x.id === action.payload.id);
      const index = entry ? state.trades.indexOf(entry) : -1;
      if (index !== -1) {
        state.trades.splice(index, 1);
      }
      state.loading = false;
      state.loaded = true;
    }
  }
});

const { actions, reducer } = recentTradeSlice;
export const { reset, loading, pending, success, fail, add, update, remove } = actions;
export default reducer;
